export var FileType;

(function (FileType) {
  FileType["PDF"] = "pdf";
  FileType["IMAGE"] = "image";
  FileType["DOCUMENT"] = "document";
  FileType["UNKNOWN"] = "unknown";
})(FileType || (FileType = {}));

export var getFileType = function getFileType(fileName) {
  if (!fileName) return FileType.UNKNOWN;
  var extension = fileName.toLowerCase().split('.').pop();
  if (!extension) return FileType.UNKNOWN; // PDF files

  if (extension === 'pdf') return FileType.PDF; // Image files

  if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg', 'ico', 'heic', 'heif'].includes(extension)) {
    return FileType.IMAGE;
  } // Document files


  if (['doc', 'docx', 'txt', 'rtf', 'odt'].includes(extension)) {
    return FileType.DOCUMENT;
  }

  return FileType.UNKNOWN;
};
export var formatFileSize = function formatFileSize(sizeInBytes) {
  if (!sizeInBytes || sizeInBytes === 0) return '0 MB';
  var sizeInMB = sizeInBytes / (1024 * 1024);
  return "".concat(sizeInMB.toFixed(1), " MB");
};
import { AttachmentFileType } from '../types/file-management.types';
export var convertFileV2ToFileAttachmentItem = function convertFileV2ToFileAttachmentItem(file) {
  var _file$mimeType, _file$size;

  var fileName = file.fileName || file.fileKey || 'Unknown file';
  var mimeType = ((_file$mimeType = file.mimeType) === null || _file$mimeType === void 0 ? void 0 : _file$mimeType.value) || ''; // Map mimeType to AttachmentFileType

  var fileType;

  if (mimeType.includes('pdf')) {
    fileType = AttachmentFileType.PDF_DOCUMENT;
  } else if (mimeType.includes('word') || mimeType.includes('document')) {
    fileType = AttachmentFileType.WORD_DOCUMENT;
  } else if (mimeType.includes('sheet') || mimeType.includes('excel')) {
    fileType = AttachmentFileType.SPREADSHEET;
  } else if (mimeType.includes('image')) {
    fileType = AttachmentFileType.IMAGE;
  } else {
    fileType = AttachmentFileType.FILE;
  }

  return {
    id: file.id.toString(),
    name: fileName,
    url: file.url,
    fileType: fileType,
    size: (_file$size = file.size) === null || _file$size === void 0 ? void 0 : _file$size.value,
    type: 'LOCAL_FILE'
  };
};